import { onMounted, onUnmounted } from "vue";
import SharedPubSub, { type PubSubCallback } from "@shared/shared.pub.sub";
import PubSubEventEnum from "@shared-enums/communication/pub.sub.event.enum";
import useStateStore from "@shared-stores/state.store";

/**
 * Composable pour écouter un événement PubSub.
 * Subscribe au onMounted, unsubscribe au onUnmounted.
 * Ne s'abonne pas en mode démo (pas de Mercure).
 *
 * usePubSub(PubSubEventEnum.ADMIN_LOST_ITEM_UPDATE, refreshData)
 * usePubSub(PubSubEventEnum.LOST_ITEM_UPDATE, refreshData)
 */
export default function usePubSub(event: PubSubEventEnum, callback: PubSubCallback)
{
	let subscribed = false;

	onMounted(() =>
	{
		const stateStore = useStateStore();

		if (stateStore.user?.isDemo)
		{
			return;
		}

		SharedPubSub.on(event, callback);
		subscribed = true;
	});

	onUnmounted(() =>
	{
		if (subscribed)
		{
			SharedPubSub.off(event, callback);
		}
	});
}
